import { Input } from "../input";
import { useFieldContext } from "./form-context";

export default function TextField({ label }: { label: string }) {
  const field = useFieldContext<string>();
  const err = field.state.meta.errors[0]?.message;
  return (
    <label className="flex flex-col gap-2">
      <div>{label}</div>
      <Input value={field.state.value} onChange={(e) => field.handleChange(e.target.value)} />
      {err && <div className="text-input-controls-error text-xs font-medium">{err}</div>}
    </label>
  );
}
